import React from 'react';
import MoConfiguration from '../MoConfiguration';

const ConfigContext = React.createContext(new MoConfiguration());

export default ConfigContext;
